import { render, staticRenderFns } from "./square.vue?vue&type=template&id=469cec26&scoped=true"
import script from "./square.vue?vue&type=script&lang=js"
export * from "./square.vue?vue&type=script&lang=js"
import style0 from "./square.vue?vue&type=style&index=0&id=469cec26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cec26",
  null
  
)

export default component.exports